import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Importar arquivos de tradução
import translationPT from "./locales/pt/translation.json";
import translationEN from "./locales/en/translation.json";
import translationES from "./locales/es/translation.json";

const resources = {
  pt: {
    translation: translationPT,
  },
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
};

i18n
  .use(LanguageDetector) // Detecta o idioma do navegador
  .use(initReactI18next) // Passa i18n para react-i18next
  .init({
    resources,
    fallbackLng: "pt", // Idioma padrão
    debug: false, // Desabilitar debug em produção

    interpolation: {
      escapeValue: false, // React já faz escape por padrão
    },

    detection: {
      // Ordem de detecção do idioma
      order: ["localStorage", "navigator", "htmlTag"],
      // Chave do localStorage
      lookupLocalStorage: "i18nextLng",
      // Cache do idioma
      caches: ["localStorage"],
    },
  });

export default i18n;


